import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { typography } from '@shared/tokens/typography.stylex';

export const styles = stylex.create({
  switcher: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    padding: '4px',
    borderRadius: '8px',
    alignItems: 'center',
    minHeight: '44px',
    height: '44px',
    backgroundColor: colors.primaryBackground,
    border: '1px solid',
    borderColor: colors.tertiaryBorder,
    color: colors.primaryText,
  },
  switcherBlock: {
    height: '100%',
    flex: '1',
    textAlign: 'center',
    cursor: 'pointer',
    alignContent: 'center',
    transition: 'background-color 0.4s ease',
    borderRadius: '4px',
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  active: {
    backgroundColor: colors.primaryInverseBackground,
    color: colors.primaryInverseText,
  },
});
